angular.module('gplans.directives').

directive("ggDateMealWeek", ["$rootScope", "dateFilter", "Mealplan", "UserService", function ($rootScope, dateFilter, Mealplan, UserService) {
  return function (scope, element, attrs) {
    function updateInfo(newValue) {
      var format = 'M/d/yy';
      var d1 = new Date(UserService.data.last_checkin.created_at),
      d2 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate() + 6);
      var weekToStr = dateFilter(d1, format) + ' - ' + dateFilter(d2, format);
      /*
                                                                               if (newValue.firstTodayUnlogedMeal && newValue.firstTodayUnlogedMeal.meal_number)
                                                                                 var meal_text = 'Meal ' + newValue.firstTodayUnlogedMeal.meal_number;
                                                                               else
                                                                                 var meal_text = "Today's Meals Tracked";
                                                                               element.text(meal_text + ' | ' +
                                                                                 'Week ' + ($rootScope.hasTwoWeeksAccelerator ?
                                                                                             UserService.data.last_checkin.week_number :
                                                                                             UserService.data.last_checkin.week_number - 2)  + ' | ' +
                                                                                 weekToStr);1
                                                                               */
      element.text('Week ' + ($rootScope.hasTwoWeeksAccelerator ?
      UserService.data.last_checkin.week_number :
      UserService.data.last_checkin.week_number - 2) + ' | ' +
      weekToStr);
    }

    Mealplan.onFirstUnloggedMealChanged(function (ver) {
      updateInfo(ver);
    });

  };
}]);